import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetCsvExcelTradesHistoryRequestModel,
    GetCsvExcelTradesHistoryResponseModel,
} from "@/features/accounts/csv-excel/services/get-trades-history-model";

export class GetCsvExcelTradesHistoryApi {
    /**
     * csv/Excel取込履歴取得API
     */
    public getCsvExcelTradesHistory = async (
        param: GetCsvExcelTradesHistoryRequestModel,
    ): Promise<GetCsvExcelTradesHistoryResponseModel> => {
        const path = `/api/csvexcelaccounts/tradeshistory`;
        const res = await ApiClient.instance.get<GetCsvExcelTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
